import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1cc0049c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mainbartop d-flex d-justify-content-center align-items-center text-center w-100"
}
const _hoisted_2 = { class: "mainbartoptext1" }
const _hoisted_3 = { class: "mainbartoptext2" }
const _hoisted_4 = { class: "mainbartoptext1" }

import { onBeforeMount, ref } from 'vue';
import axios from 'axios';
import moment from 'moment';
import VueCountdown from '@chenfengyuan/vue-countdown';
import { userMainStore } from '@/store/userMainStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainDarkBarTop',
  setup(__props) {

const main = userMainStore();
let token = localStorage.getItem("token");
const subscription = ref();
const duration = ref();
const show = ref(false);

onBeforeMount(
	async () => {
		if (main.isavailable) await getSubscription();
		getTimeLeft();
	});


function getTimeLeft() {
	if (!subscription.value) return;
	let enddate = moment(subscription.value.sduntildate);
	let todaysdate = moment(subscription.value.now);
	let timeleft = enddate.diff(todaysdate, 'milliseconds');
	duration.value = moment.duration(timeleft, 'milliseconds');
}

function getSubscription() {
	return new Promise(async (resolve) => {
		await axios
			.get('/api/v1/getsubscription/' + 6, {
				headers: { Authorization: `${token}` },
				withCredentials: true
			})
			.then(response => {
				subscription.value = response.data.Data;
				if (subscription.value.sdpromo) {
					show.value = true;
				}
				resolve(true);
			});
	})
}

return (_ctx: any,_cache: any) => {
  return (show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('promobar.limitedtimeSale', 'Limited-Time Sale')) + ": ", 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(subscription.value?.scdiscount) + "% Off", 1),
          _createTextVNode(),
          _createElementVNode("b", null, _toDisplayString(subscription.value?.stdescription), 1),
          _createTextVNode(", " + _toDisplayString(_ctx.$t('promobar.yoursnow', 'Grab Yours Now!')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(VueCountdown), { time: duration.value }, {
            default: _withCtx(({ days, hours, minutes, seconds }) => [
              _createTextVNode(" - " + _toDisplayString(_ctx.$t('promobar.timeremaining', 'Time Remaining')) + "：" + _toDisplayString(days) + " " + _toDisplayString(_ctx.$t('common.days', 'days')) + " , " + _toDisplayString(hours) + " " + _toDisplayString(_ctx.$t('common.hours', 'hours')) + " , " + _toDisplayString(minutes) + " " + _toDisplayString(_ctx.$t('common.minutes', 'minutes')) + ", " + _toDisplayString(seconds) + " " + _toDisplayString(_ctx.$t('common.seconds', 'seconds')), 1)
            ]),
            _: 1
          }, 8, ["time"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})